// Generated by tools/photos/install_photos.py from docs/final-photo-review/photo-plan.json.
// Do not edit by hand. Spaces without an entry keep their labeled placeholder.
export const PHOTO_ASSETS = Object.freeze({
 "A01": {
  "alt": "Indoor basketball court at Delta Valley Health Club",
  "focus": "50% 55%",
  "height": 4000,
  "sizes": "(max-width: 640px) 310px, 532px",
  "src": "/images/photos/basketball-court-1280.jpg",
  "srcSet": "/images/photos/basketball-court-640.jpg 640w, /images/photos/basketball-court-1280.jpg 1280w, /images/photos/basketball-court-1920.jpg 1920w, /images/photos/basketball-court-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/basketball-court-640.webp 640w, /images/photos/basketball-court-1280.webp 1280w, /images/photos/basketball-court-1920.webp 1920w, /images/photos/basketball-court-2560.webp 2560w",
  "width": 6016
 },
 "A02": {
  "alt": "Indoor lap pool at Delta Valley Health Club",
  "focus": "50% 55%",
  "height": 4000,
  "sizes": "(max-width: 640px) 310px, 532px",
  "src": "/images/photos/lap-pool-1280.jpg",
  "srcSet": "/images/photos/lap-pool-640.jpg 640w, /images/photos/lap-pool-1280.jpg 1280w, /images/photos/lap-pool-1920.jpg 1920w, /images/photos/lap-pool-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/lap-pool-640.webp 640w, /images/photos/lap-pool-1280.webp 1280w, /images/photos/lap-pool-1920.webp 1920w, /images/photos/lap-pool-2560.webp 2560w",
  "width": 5775
 },
 "A03": {
  "alt": "Strength-training floor with racks beside the climbing wall",
  "focus": "50% 50%",
  "height": 1448,
  "sizes": "(max-width: 640px) 310px, 532px",
  "src": "/images/photos/strength-floor-1280.jpg",
  "srcSet": "/images/photos/strength-floor-640.jpg 640w, /images/photos/strength-floor-1280.jpg 1280w, /images/photos/strength-floor-1920.jpg 1920w, /images/photos/strength-floor-2172.jpg 2172w",
  "webpSrcSet": "/images/photos/strength-floor-640.webp 640w, /images/photos/strength-floor-1280.webp 1280w, /images/photos/strength-floor-1920.webp 1920w, /images/photos/strength-floor-2172.webp 2172w",
  "width": 2172
 },
 "A06": {
  "alt": "The climbing wall rising beside the strength-training racks",
  "focus": "20% 50%",
  "height": 1448,
  "sizes": "(max-width: 640px) 390px, 1440px",
  "src": "/images/photos/strength-floor-1280.jpg",
  "srcSet": "/images/photos/strength-floor-640.jpg 640w, /images/photos/strength-floor-1280.jpg 1280w, /images/photos/strength-floor-1920.jpg 1920w, /images/photos/strength-floor-2172.jpg 2172w",
  "webpSrcSet": "/images/photos/strength-floor-640.webp 640w, /images/photos/strength-floor-1280.webp 1280w, /images/photos/strength-floor-1920.webp 1920w, /images/photos/strength-floor-2172.webp 2172w",
  "width": 2172
 },
 "A09": {
  "alt": "Strength-training floor",
  "focus": "50% 50%",
  "height": 800,
  "sizes": "(max-width: 640px) 390px, 1440px",
  "src": "/images/facility/green-room-1.jpg",
  "width": 1200
 },
 "A10": {
  "alt": "Cardio floor with treadmills",
  "focus": "50% 50%",
  "height": 800,
  "sizes": "(max-width: 640px) 390px, 1440px",
  "src": "/images/facility/cardio-room.jpg",
  "width": 1200
 },
 "C01": {
  "alt": "Delta Valley Health Club entrance sign",
  "focus": "46% 38%",
  "height": 6000,
  "sizes": "(max-width: 640px) 320px, 320px",
  "src": "/images/photos/club-entrance-1280.jpg",
  "srcSet": "/images/photos/club-entrance-640.jpg 640w, /images/photos/club-entrance-1280.jpg 1280w, /images/photos/club-entrance-1920.jpg 1920w, /images/photos/club-entrance-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/club-entrance-640.webp 640w, /images/photos/club-entrance-1280.webp 1280w, /images/photos/club-entrance-1920.webp 1920w, /images/photos/club-entrance-2560.webp 2560w",
  "width": 4000
 },
 "C02": {
  "alt": "Three members smiling beside the bikes in the spin studio",
  "focus": "50% 0%",
  "height": 969,
  "sizes": "(max-width: 640px) 390px, 760px",
  "src": "/images/photos/spin-studio-1280.jpg",
  "srcSet": "/images/photos/spin-studio-640.jpg 640w, /images/photos/spin-studio-1280.jpg 1280w, /images/photos/spin-studio-1638.jpg 1638w",
  "webpSrcSet": "/images/photos/spin-studio-640.webp 640w, /images/photos/spin-studio-1280.webp 1280w, /images/photos/spin-studio-1638.webp 1638w",
  "width": 1638
 },
 "C03": {
  "alt": "Members in a kickboxing class with heavy bags",
  "focus": "40% 40%",
  "height": 5760,
  "sizes": "(max-width: 640px) 350px, 423px",
  "src": "/images/photos/kickboxing-studio-1280.jpg",
  "srcSet": "/images/photos/kickboxing-studio-640.jpg 640w, /images/photos/kickboxing-studio-1280.jpg 1280w, /images/photos/kickboxing-studio-1920.jpg 1920w, /images/photos/kickboxing-studio-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/kickboxing-studio-640.webp 640w, /images/photos/kickboxing-studio-1280.webp 1280w, /images/photos/kickboxing-studio-1920.webp 1920w, /images/photos/kickboxing-studio-2560.webp 2560w",
  "width": 8640
 },
 "C05": {
  "alt": "Children playing in the Kid's Club play area",
  "focus": "50% 35%",
  "height": 5857,
  "sizes": "(max-width: 640px) 390px, 720px",
  "src": "/images/photos/kids-club-1280.jpg",
  "srcSet": "/images/photos/kids-club-640.jpg 640w, /images/photos/kids-club-1280.jpg 1280w, /images/photos/kids-club-1920.jpg 1920w, /images/photos/kids-club-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/kids-club-640.webp 640w, /images/photos/kids-club-1280.webp 1280w, /images/photos/kids-club-1920.webp 1920w, /images/photos/kids-club-2560.webp 2560w",
  "width": 5010
 },
 "H05": {
  "alt": "A 35-pound dumbbell, gym bag and water bottle on the weight floor",
  "focus": "42% 62%",
  "height": 4000,
  "sizes": "(max-width: 640px) 348px, 382px",
  "src": "/images/photos/free-weights-1280.jpg",
  "srcSet": "/images/photos/free-weights-640.jpg 640w, /images/photos/free-weights-1280.jpg 1280w, /images/photos/free-weights-1920.jpg 1920w, /images/photos/free-weights-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/free-weights-640.webp 640w, /images/photos/free-weights-1280.webp 1280w, /images/photos/free-weights-1920.webp 1920w, /images/photos/free-weights-2560.webp 2560w",
  "width": 6000
 },
 "H06": {
  "alt": "Members on Reformer towers in the Pilates studio",
  "focus": "46% 0%",
  "height": 1365,
  "sizes": "(max-width: 640px) 348px, 382px",
  "src": "/images/photos/reformer-studio-1280.jpg",
  "srcSet": "/images/photos/reformer-studio-640.jpg 640w, /images/photos/reformer-studio-1280.jpg 1280w, /images/photos/reformer-studio-1920.jpg 1920w, /images/photos/reformer-studio-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/reformer-studio-640.webp 640w, /images/photos/reformer-studio-1280.webp 1280w, /images/photos/reformer-studio-1920.webp 1920w, /images/photos/reformer-studio-2048.webp 2048w",
  "width": 2048
 },
 "H07": {
  "alt": "Goggles, towel, kickboard and life ring beside the lap pool",
  "focus": "42% 58%",
  "height": 4000,
  "sizes": "(max-width: 640px) 348px, 382px",
  "src": "/images/photos/swim-gear-1280.jpg",
  "srcSet": "/images/photos/swim-gear-640.jpg 640w, /images/photos/swim-gear-1280.jpg 1280w, /images/photos/swim-gear-1920.jpg 1920w, /images/photos/swim-gear-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/swim-gear-640.webp 640w, /images/photos/swim-gear-1280.webp 1280w, /images/photos/swim-gear-1920.webp 1920w, /images/photos/swim-gear-2560.webp 2560w",
  "width": 6000
 },
 "H08": {
  "alt": "An MX4 coach leading a small-group class on rowers and wall-ball squats",
  "focus": "60% 0%",
  "height": 1293,
  "sizes": "(max-width: 640px) 348px, 790px",
  "src": "/images/photos/mx4-studio-1280.jpg",
  "srcSet": "/images/photos/mx4-studio-640.jpg 640w, /images/photos/mx4-studio-1280.jpg 1280w, /images/photos/mx4-studio-1920.jpg 1920w, /images/photos/mx4-studio-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/mx4-studio-640.webp 640w, /images/photos/mx4-studio-1280.webp 1280w, /images/photos/mx4-studio-1920.webp 1920w, /images/photos/mx4-studio-2048.webp 2048w",
  "width": 2048
 },
 "H09": {
  "alt": "Children playing in the Kid's Club play area",
  "focus": "50% 35%",
  "height": 5857,
  "sizes": "(max-width: 640px) 348px, 382px",
  "src": "/images/photos/kids-club-1280.jpg",
  "srcSet": "/images/photos/kids-club-640.jpg 640w, /images/photos/kids-club-1280.jpg 1280w, /images/photos/kids-club-1920.jpg 1920w, /images/photos/kids-club-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/kids-club-640.webp 640w, /images/photos/kids-club-1280.webp 1280w, /images/photos/kids-club-1920.webp 1920w, /images/photos/kids-club-2560.webp 2560w",
  "width": 5010
 },
 "H11": {
  "alt": "Three members smiling beside the bikes in the spin studio",
  "focus": "50% 0%",
  "height": 969,
  "sizes": "(max-width: 640px) 348px, 382px",
  "src": "/images/photos/spin-studio-1280.jpg",
  "srcSet": "/images/photos/spin-studio-640.jpg 640w, /images/photos/spin-studio-1280.jpg 1280w, /images/photos/spin-studio-1638.jpg 1638w",
  "webpSrcSet": "/images/photos/spin-studio-640.webp 640w, /images/photos/spin-studio-1280.webp 1280w, /images/photos/spin-studio-1638.webp 1638w",
  "width": 1638
 },
 "H12": {
  "alt": "Members holding a balance pose on yoga mats in a group class",
  "focus": "55% 32%",
  "height": 1275,
  "sizes": "(max-width: 640px) 348px, 382px",
  "src": "/images/photos/mind-body-class-1280.jpg",
  "srcSet": "/images/photos/mind-body-class-640.jpg 640w, /images/photos/mind-body-class-1280.jpg 1280w, /images/photos/mind-body-class-1920.jpg 1920w, /images/photos/mind-body-class-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/mind-body-class-640.webp 640w, /images/photos/mind-body-class-1280.webp 1280w, /images/photos/mind-body-class-1920.webp 1920w, /images/photos/mind-body-class-2048.webp 2048w",
  "width": 2048
 },
 "H13": {
  "alt": "Members lined up for barbell deadlifts in a group strength class",
  "focus": "62% 0%",
  "height": 1416,
  "sizes": "(max-width: 640px) 348px, 382px",
  "src": "/images/photos/strength-class-1280.jpg",
  "srcSet": "/images/photos/strength-class-640.jpg 640w, /images/photos/strength-class-1280.jpg 1280w, /images/photos/strength-class-1920.jpg 1920w, /images/photos/strength-class-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/strength-class-640.webp 640w, /images/photos/strength-class-1280.webp 1280w, /images/photos/strength-class-1920.webp 1920w, /images/photos/strength-class-2048.webp 2048w",
  "width": 2048
 },
 "H14": {
  "alt": "Members in a kickboxing class with heavy bags",
  "focus": "40% 40%",
  "height": 5760,
  "sizes": "(max-width: 640px) 348px, 790px",
  "src": "/images/photos/kickboxing-studio-1280.jpg",
  "srcSet": "/images/photos/kickboxing-studio-640.jpg 640w, /images/photos/kickboxing-studio-1280.jpg 1280w, /images/photos/kickboxing-studio-1920.jpg 1920w, /images/photos/kickboxing-studio-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/kickboxing-studio-640.webp 640w, /images/photos/kickboxing-studio-1280.webp 1280w, /images/photos/kickboxing-studio-1920.webp 1920w, /images/photos/kickboxing-studio-2560.webp 2560w",
  "width": 8640
 },
 "P00": {
  "alt": "Members lined up for barbell deadlifts in a group strength class",
  "focus": "62% 0%",
  "height": 1416,
  "sizes": "(max-width: 640px) 390px, 1440px",
  "src": "/images/photos/strength-class-1280.jpg",
  "srcSet": "/images/photos/strength-class-640.jpg 640w, /images/photos/strength-class-1280.jpg 1280w, /images/photos/strength-class-1920.jpg 1920w, /images/photos/strength-class-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/strength-class-640.webp 640w, /images/photos/strength-class-1280.webp 1280w, /images/photos/strength-class-1920.webp 1920w, /images/photos/strength-class-2048.webp 2048w",
  "width": 2048
 },
 "P01": {
  "alt": "Members on Reformer towers in the Pilates studio",
  "focus": "46% 0%",
  "height": 1365,
  "sizes": "(max-width: 640px) 350px, 1440px",
  "src": "/images/photos/reformer-studio-1280.jpg",
  "srcSet": "/images/photos/reformer-studio-640.jpg 640w, /images/photos/reformer-studio-1280.jpg 1280w, /images/photos/reformer-studio-1920.jpg 1920w, /images/photos/reformer-studio-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/reformer-studio-640.webp 640w, /images/photos/reformer-studio-1280.webp 1280w, /images/photos/reformer-studio-1920.webp 1920w, /images/photos/reformer-studio-2048.webp 2048w",
  "width": 2048
 },
 "P02": {
  "alt": "An MX4 coach leading a small-group class on rowers and wall-ball squats",
  "focus": "60% 0%",
  "height": 1293,
  "sizes": "(max-width: 640px) 350px, 1440px",
  "src": "/images/photos/mx4-studio-1280.jpg",
  "srcSet": "/images/photos/mx4-studio-640.jpg 640w, /images/photos/mx4-studio-1280.jpg 1280w, /images/photos/mx4-studio-1920.jpg 1920w, /images/photos/mx4-studio-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/mx4-studio-640.webp 640w, /images/photos/mx4-studio-1280.webp 1280w, /images/photos/mx4-studio-1920.webp 1920w, /images/photos/mx4-studio-2048.webp 2048w",
  "width": 2048
 },
 "P03": {
  "alt": "A 35-pound dumbbell, gym bag and water bottle on the weight floor",
  "focus": "42% 62%",
  "height": 4000,
  "sizes": "(max-width: 640px) 390px, 697px",
  "src": "/images/photos/free-weights-1280.jpg",
  "srcSet": "/images/photos/free-weights-640.jpg 640w, /images/photos/free-weights-1280.jpg 1280w, /images/photos/free-weights-1920.jpg 1920w, /images/photos/free-weights-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/free-weights-640.webp 640w, /images/photos/free-weights-1280.webp 1280w, /images/photos/free-weights-1920.webp 1920w, /images/photos/free-weights-2560.webp 2560w",
  "width": 6000
 },
 "P04": {
  "alt": "Goggles, towel, kickboard and life ring beside the lap pool",
  "focus": "42% 58%",
  "height": 4000,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/swim-gear-1280.jpg",
  "srcSet": "/images/photos/swim-gear-640.jpg 640w, /images/photos/swim-gear-1280.jpg 1280w, /images/photos/swim-gear-1920.jpg 1920w, /images/photos/swim-gear-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/swim-gear-640.webp 640w, /images/photos/swim-gear-1280.webp 1280w, /images/photos/swim-gear-1920.webp 1920w, /images/photos/swim-gear-2560.webp 2560w",
  "width": 6000
 },
 "P05": {
  "alt": "Children playing in the Kid's Club play area",
  "focus": "50% 35%",
  "height": 5857,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/kids-club-1280.jpg",
  "srcSet": "/images/photos/kids-club-640.jpg 640w, /images/photos/kids-club-1280.jpg 1280w, /images/photos/kids-club-1920.jpg 1920w, /images/photos/kids-club-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/kids-club-640.webp 640w, /images/photos/kids-club-1280.webp 1280w, /images/photos/kids-club-1920.webp 1920w, /images/photos/kids-club-2560.webp 2560w",
  "width": 5010
 },
 "P07": {
  "alt": "Three members smiling beside the bikes in the spin studio",
  "focus": "50% 0%",
  "height": 969,
  "sizes": "(max-width: 640px) 350px, 630px",
  "src": "/images/photos/spin-studio-1280.jpg",
  "srcSet": "/images/photos/spin-studio-640.jpg 640w, /images/photos/spin-studio-1280.jpg 1280w, /images/photos/spin-studio-1638.jpg 1638w",
  "webpSrcSet": "/images/photos/spin-studio-640.webp 640w, /images/photos/spin-studio-1280.webp 1280w, /images/photos/spin-studio-1638.webp 1638w",
  "width": 1638
 },
 "P08": {
  "alt": "Members holding a balance pose on yoga mats in a group class",
  "focus": "55% 32%",
  "height": 1275,
  "sizes": "(max-width: 640px) 350px, 630px",
  "src": "/images/photos/mind-body-class-1280.jpg",
  "srcSet": "/images/photos/mind-body-class-640.jpg 640w, /images/photos/mind-body-class-1280.jpg 1280w, /images/photos/mind-body-class-1920.jpg 1920w, /images/photos/mind-body-class-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/mind-body-class-640.webp 640w, /images/photos/mind-body-class-1280.webp 1280w, /images/photos/mind-body-class-1920.webp 1920w, /images/photos/mind-body-class-2048.webp 2048w",
  "width": 2048
 },
 "amenities-hero": {
  "alt": "Delta Valley Health Club building and entrance with palm trees",
  "focus": "50% 60%",
  "height": 4000,
  "sizes": "(max-width: 640px) 390px, 1440px",
  "src": "/images/photos/club-exterior-1280.jpg",
  "srcSet": "/images/photos/club-exterior-640.jpg 640w, /images/photos/club-exterior-1280.jpg 1280w, /images/photos/club-exterior-1920.jpg 1920w, /images/photos/club-exterior-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/club-exterior-640.webp 640w, /images/photos/club-exterior-1280.webp 1280w, /images/photos/club-exterior-1920.webp 1920w, /images/photos/club-exterior-2560.webp 2560w",
  "width": 6016
 },
 "article-aqua-jogging-pool-walking-the-low-impact-cardio-youre-missing": {
  "alt": "Indoor lap pool at Delta Valley Health Club",
  "focus": "50% 55%",
  "height": 4000,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/lap-pool-1280.jpg",
  "srcSet": "/images/photos/lap-pool-640.jpg 640w, /images/photos/lap-pool-1280.jpg 1280w, /images/photos/lap-pool-1920.jpg 1920w, /images/photos/lap-pool-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/lap-pool-640.webp 640w, /images/photos/lap-pool-1280.webp 1280w, /images/photos/lap-pool-1920.webp 1920w, /images/photos/lap-pool-2560.webp 2560w",
  "width": 5775
 },
 "article-can-you-do-reformer-pilates-while-pregnant": {
  "alt": "Members on Reformer towers in the Pilates studio",
  "focus": "46% 0%",
  "height": 1365,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/reformer-studio-1280.jpg",
  "srcSet": "/images/photos/reformer-studio-640.jpg 640w, /images/photos/reformer-studio-1280.jpg 1280w, /images/photos/reformer-studio-1920.jpg 1920w, /images/photos/reformer-studio-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/reformer-studio-640.webp 640w, /images/photos/reformer-studio-1280.webp 1280w, /images/photos/reformer-studio-1920.webp 1920w, /images/photos/reformer-studio-2048.webp 2048w",
  "width": 2048
 },
 "article-dive-in-and-trim-down-unpacking-the-calories-burned-in-water-aerobics": {
  "alt": "Indoor lap pool at Delta Valley Health Club",
  "focus": "50% 55%",
  "height": 4000,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/lap-pool-1280.jpg",
  "srcSet": "/images/photos/lap-pool-640.jpg 640w, /images/photos/lap-pool-1280.jpg 1280w, /images/photos/lap-pool-1920.jpg 1920w, /images/photos/lap-pool-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/lap-pool-640.webp 640w, /images/photos/lap-pool-1280.webp 1280w, /images/photos/lap-pool-1920.webp 1920w, /images/photos/lap-pool-2560.webp 2560w",
  "width": 5775
 },
 "article-does-pilates-help-you-lose-weight": {
  "alt": "Members on Reformer towers in the Pilates studio",
  "focus": "46% 0%",
  "height": 1365,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/reformer-studio-1280.jpg",
  "srcSet": "/images/photos/reformer-studio-640.jpg 640w, /images/photos/reformer-studio-1280.jpg 1280w, /images/photos/reformer-studio-1920.jpg 1920w, /images/photos/reformer-studio-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/reformer-studio-640.webp 640w, /images/photos/reformer-studio-1280.webp 1280w, /images/photos/reformer-studio-1920.webp 1920w, /images/photos/reformer-studio-2048.webp 2048w",
  "width": 2048
 },
 "article-gym-with-childcare-in-brentwood-work-out-while-your-kids-play": {
  "alt": "Children playing in the Kid's Club play area",
  "focus": "50% 35%",
  "height": 5857,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/kids-club-1280.jpg",
  "srcSet": "/images/photos/kids-club-640.jpg 640w, /images/photos/kids-club-1280.jpg 1280w, /images/photos/kids-club-1920.jpg 1920w, /images/photos/kids-club-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/kids-club-640.webp 640w, /images/photos/kids-club-1280.webp 1280w, /images/photos/kids-club-1920.webp 1920w, /images/photos/kids-club-2560.webp 2560w",
  "width": 5010
 },
 "article-how-much-does-a-personal-trainer-cost": {
  "alt": "Strength-training floor",
  "focus": "50% 50%",
  "height": 800,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/facility/green-room-1.jpg",
  "width": 1200
 },
 "article-how-much-does-a-pilates-class-cost": {
  "alt": "Members on Reformer towers in the Pilates studio",
  "focus": "46% 0%",
  "height": 1365,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/reformer-studio-1280.jpg",
  "srcSet": "/images/photos/reformer-studio-640.jpg 640w, /images/photos/reformer-studio-1280.jpg 1280w, /images/photos/reformer-studio-1920.jpg 1920w, /images/photos/reformer-studio-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/reformer-studio-640.webp 640w, /images/photos/reformer-studio-1280.webp 1280w, /images/photos/reformer-studio-1920.webp 1920w, /images/photos/reformer-studio-2048.webp 2048w",
  "width": 2048
 },
 "article-how-often-to-do-hiit-training": {
  "alt": "MX4 small-group training session",
  "focus": "50% 50%",
  "height": 800,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/mx4/mx4-group.webp",
  "width": 1200
 },
 "article-indoor-cycling-spin-classes-guide": {
  "alt": "Cardio floor with treadmills",
  "focus": "50% 50%",
  "height": 800,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/facility/cardio-room.jpg",
  "width": 1200
 },
 "article-is-hiit-safe-during-pregnancy": {
  "alt": "MX4 small-group training session",
  "focus": "50% 50%",
  "height": 800,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/mx4/mx4-group.webp",
  "width": 1200
 },
 "article-is-hiit-strength-training": {
  "alt": "MX4 small-group training session",
  "focus": "50% 50%",
  "height": 800,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/mx4/mx4-group.webp",
  "width": 1200
 },
 "article-is-water-aerobics-good-for-weight-loss": {
  "alt": "Indoor lap pool at Delta Valley Health Club",
  "focus": "50% 55%",
  "height": 4000,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/lap-pool-1280.jpg",
  "srcSet": "/images/photos/lap-pool-640.jpg 640w, /images/photos/lap-pool-1280.jpg 1280w, /images/photos/lap-pool-1920.jpg 1920w, /images/photos/lap-pool-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/lap-pool-640.webp 640w, /images/photos/lap-pool-1280.webp 1280w, /images/photos/lap-pool-1920.webp 1920w, /images/photos/lap-pool-2560.webp 2560w",
  "width": 5775
 },
 "article-mat-pilates-vs-reformer-pilates-which-is-right-for-you": {
  "alt": "Members on Reformer towers in the Pilates studio",
  "focus": "46% 0%",
  "height": 1365,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/reformer-studio-1280.jpg",
  "srcSet": "/images/photos/reformer-studio-640.jpg 640w, /images/photos/reformer-studio-1280.jpg 1280w, /images/photos/reformer-studio-1920.jpg 1920w, /images/photos/reformer-studio-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/reformer-studio-640.webp 640w, /images/photos/reformer-studio-1280.webp 1280w, /images/photos/reformer-studio-1920.webp 1920w, /images/photos/reformer-studio-2048.webp 2048w",
  "width": 2048
 },
 "article-mx4-workout": {
  "alt": "MX4 small-group training session",
  "focus": "50% 50%",
  "height": 800,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/mx4/mx4-group.webp",
  "width": 1200
 },
 "article-power-stretch": {
  "alt": "Members on Reformer towers in the Pilates studio",
  "focus": "46% 0%",
  "height": 1365,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/reformer-studio-1280.jpg",
  "srcSet": "/images/photos/reformer-studio-640.jpg 640w, /images/photos/reformer-studio-1280.jpg 1280w, /images/photos/reformer-studio-1920.jpg 1920w, /images/photos/reformer-studio-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/reformer-studio-640.webp 640w, /images/photos/reformer-studio-1280.webp 1280w, /images/photos/reformer-studio-1920.webp 1920w, /images/photos/reformer-studio-2048.webp 2048w",
  "width": 2048
 },
 "article-senior-fitness-classes-brentwood": {
  "alt": "Group barbell class",
  "focus": "50% 50%",
  "height": 800,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/facility/fit-bright.jpg",
  "width": 1200
 },
 "article-small-group-personal-training": {
  "alt": "Strength-training floor",
  "focus": "50% 50%",
  "height": 800,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/facility/green-room-1.jpg",
  "width": 1200
 },
 "article-small-group-training": {
  "alt": "MX4 small-group training session",
  "focus": "50% 50%",
  "height": 800,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/mx4/mx4-group.webp",
  "width": 1200
 },
 "article-the-complete-guide-to-water-fitness-at-delta-valley-from-aqua-aerobics-to-deep-water-training": {
  "alt": "Indoor lap pool at Delta Valley Health Club",
  "focus": "50% 55%",
  "height": 4000,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/lap-pool-1280.jpg",
  "srcSet": "/images/photos/lap-pool-640.jpg 640w, /images/photos/lap-pool-1280.jpg 1280w, /images/photos/lap-pool-1920.jpg 1920w, /images/photos/lap-pool-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/lap-pool-640.webp 640w, /images/photos/lap-pool-1280.webp 1280w, /images/photos/lap-pool-1920.webp 1920w, /images/photos/lap-pool-2560.webp 2560w",
  "width": 5775
 },
 "article-transform-your-core-the-ultimate-guide-to-exercise-ball-core-strength-training": {
  "alt": "Strength-training floor",
  "focus": "50% 50%",
  "height": 800,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/facility/green-room-1.jpg",
  "width": 1200
 },
 "article-what-is-reformer-pilates": {
  "alt": "Members on Reformer towers in the Pilates studio",
  "focus": "46% 0%",
  "height": 1365,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/reformer-studio-1280.jpg",
  "srcSet": "/images/photos/reformer-studio-640.jpg 640w, /images/photos/reformer-studio-1280.jpg 1280w, /images/photos/reformer-studio-1920.jpg 1920w, /images/photos/reformer-studio-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/reformer-studio-640.webp 640w, /images/photos/reformer-studio-1280.webp 1280w, /images/photos/reformer-studio-1920.webp 1920w, /images/photos/reformer-studio-2048.webp 2048w",
  "width": 2048
 },
 "article-what-to-wear-to-pilates": {
  "alt": "Members on Reformer towers in the Pilates studio",
  "focus": "46% 0%",
  "height": 1365,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/reformer-studio-1280.jpg",
  "srcSet": "/images/photos/reformer-studio-640.jpg 640w, /images/photos/reformer-studio-1280.jpg 1280w, /images/photos/reformer-studio-1920.jpg 1920w, /images/photos/reformer-studio-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/reformer-studio-640.webp 640w, /images/photos/reformer-studio-1280.webp 1280w, /images/photos/reformer-studio-1920.webp 1920w, /images/photos/reformer-studio-2048.webp 2048w",
  "width": 2048
 },
 "article-when-to-start-swim-lessons": {
  "alt": "Indoor lap pool at Delta Valley Health Club",
  "focus": "50% 55%",
  "height": 4000,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/lap-pool-1280.jpg",
  "srcSet": "/images/photos/lap-pool-640.jpg 640w, /images/photos/lap-pool-1280.jpg 1280w, /images/photos/lap-pool-1920.jpg 1920w, /images/photos/lap-pool-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/lap-pool-640.webp 640w, /images/photos/lap-pool-1280.webp 1280w, /images/photos/lap-pool-1920.webp 1920w, /images/photos/lap-pool-2560.webp 2560w",
  "width": 5775
 },
 "article-yoga-flow-class": {
  "alt": "Members on Reformer towers in the Pilates studio",
  "focus": "46% 0%",
  "height": 1365,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/reformer-studio-1280.jpg",
  "srcSet": "/images/photos/reformer-studio-640.jpg 640w, /images/photos/reformer-studio-1280.jpg 1280w, /images/photos/reformer-studio-1920.jpg 1920w, /images/photos/reformer-studio-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/reformer-studio-640.webp 640w, /images/photos/reformer-studio-1280.webp 1280w, /images/photos/reformer-studio-1920.webp 1920w, /images/photos/reformer-studio-2048.webp 2048w",
  "width": 2048
 },
 "article-yoga-muscle-fusion": {
  "alt": "Members on Reformer towers in the Pilates studio",
  "focus": "46% 0%",
  "height": 1365,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/reformer-studio-1280.jpg",
  "srcSet": "/images/photos/reformer-studio-640.jpg 640w, /images/photos/reformer-studio-1280.jpg 1280w, /images/photos/reformer-studio-1920.jpg 1920w, /images/photos/reformer-studio-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/reformer-studio-640.webp 640w, /images/photos/reformer-studio-1280.webp 1280w, /images/photos/reformer-studio-1920.webp 1920w, /images/photos/reformer-studio-2048.webp 2048w",
  "width": 2048
 },
 "article-youth-swimming-programs-in-brentwood-discovery-bay-delta-valleys-complete-parent-guide": {
  "alt": "Indoor lap pool at Delta Valley Health Club",
  "focus": "50% 55%",
  "height": 4000,
  "sizes": "(max-width: 640px) 350px, 493px",
  "src": "/images/photos/lap-pool-1280.jpg",
  "srcSet": "/images/photos/lap-pool-640.jpg 640w, /images/photos/lap-pool-1280.jpg 1280w, /images/photos/lap-pool-1920.jpg 1920w, /images/photos/lap-pool-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/lap-pool-640.webp 640w, /images/photos/lap-pool-1280.webp 1280w, /images/photos/lap-pool-1920.webp 1920w, /images/photos/lap-pool-2560.webp 2560w",
  "width": 5775
 },
 "coach-andy": {
  "alt": "Andy, Fitness Director and MX4 coach at Delta Valley Health Club",
  "focus": "50% 40%",
  "height": 5334,
  "sizes": "(max-width: 640px) 112px, 160px",
  "src": "/images/photos/coach-andy-1280.jpg",
  "srcSet": "/images/photos/coach-andy-640.jpg 640w, /images/photos/coach-andy-1280.jpg 1280w, /images/photos/coach-andy-1920.jpg 1920w, /images/photos/coach-andy-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/coach-andy-640.webp 640w, /images/photos/coach-andy-1280.webp 1280w, /images/photos/coach-andy-1920.webp 1920w, /images/photos/coach-andy-2560.webp 2560w",
  "width": 4000
 },
 "coach-cheri": {
  "alt": "Cheri, MX4 coach at Delta Valley Health Club",
  "focus": "50% 40%",
  "height": 5334,
  "sizes": "(max-width: 640px) 358px, 352px",
  "src": "/images/photos/coach-cheri-1280.jpg",
  "srcSet": "/images/photos/coach-cheri-640.jpg 640w, /images/photos/coach-cheri-1280.jpg 1280w, /images/photos/coach-cheri-1920.jpg 1920w, /images/photos/coach-cheri-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/coach-cheri-640.webp 640w, /images/photos/coach-cheri-1280.webp 1280w, /images/photos/coach-cheri-1920.webp 1920w, /images/photos/coach-cheri-2560.webp 2560w",
  "width": 4000
 },
 "coach-jenn-l": {
  "alt": "Jenn, MX4 coach at Delta Valley Health Club",
  "focus": "50% 40%",
  "height": 5334,
  "sizes": "(max-width: 640px) 112px, 160px",
  "src": "/images/photos/coach-jenn-l-1280.jpg",
  "srcSet": "/images/photos/coach-jenn-l-640.jpg 640w, /images/photos/coach-jenn-l-1280.jpg 1280w, /images/photos/coach-jenn-l-1920.jpg 1920w, /images/photos/coach-jenn-l-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/coach-jenn-l-640.webp 640w, /images/photos/coach-jenn-l-1280.webp 1280w, /images/photos/coach-jenn-l-1920.webp 1920w, /images/photos/coach-jenn-l-2560.webp 2560w",
  "width": 4000
 },
 "coach-john": {
  "alt": "John, MX4 coach at Delta Valley Health Club",
  "focus": "50% 40%",
  "height": 5334,
  "sizes": "(max-width: 640px) 112px, 160px",
  "src": "/images/photos/coach-john-1280.jpg",
  "srcSet": "/images/photos/coach-john-640.jpg 640w, /images/photos/coach-john-1280.jpg 1280w, /images/photos/coach-john-1920.jpg 1920w, /images/photos/coach-john-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/coach-john-640.webp 640w, /images/photos/coach-john-1280.webp 1280w, /images/photos/coach-john-1920.webp 1920w, /images/photos/coach-john-2560.webp 2560w",
  "width": 4000
 },
 "coach-lyndsey": {
  "alt": "Lyndsey, MX4 coach at Delta Valley Health Club",
  "focus": "50% 40%",
  "height": 5334,
  "sizes": "(max-width: 640px) 358px, 352px",
  "src": "/images/photos/coach-lyndsey-1280.jpg",
  "srcSet": "/images/photos/coach-lyndsey-640.jpg 640w, /images/photos/coach-lyndsey-1280.jpg 1280w, /images/photos/coach-lyndsey-1920.jpg 1920w, /images/photos/coach-lyndsey-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/coach-lyndsey-640.webp 640w, /images/photos/coach-lyndsey-1280.webp 1280w, /images/photos/coach-lyndsey-1920.webp 1920w, /images/photos/coach-lyndsey-2560.webp 2560w",
  "width": 4000
 },
 "coach-pam": {
  "alt": "Pam, MX4 coach at Delta Valley Health Club",
  "focus": "50% 40%",
  "height": 5334,
  "sizes": "(max-width: 640px) 112px, 160px",
  "src": "/images/photos/coach-pam-1280.jpg",
  "srcSet": "/images/photos/coach-pam-640.jpg 640w, /images/photos/coach-pam-1280.jpg 1280w, /images/photos/coach-pam-1920.jpg 1920w, /images/photos/coach-pam-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/coach-pam-640.webp 640w, /images/photos/coach-pam-1280.webp 1280w, /images/photos/coach-pam-1920.webp 1920w, /images/photos/coach-pam-2560.webp 2560w",
  "width": 4000
 },
 "coach-tina": {
  "alt": "Tina, MX4 coach at Delta Valley Health Club",
  "focus": "50% 40%",
  "height": 5334,
  "sizes": "(max-width: 640px) 358px, 352px",
  "src": "/images/photos/coach-tina-1280.jpg",
  "srcSet": "/images/photos/coach-tina-640.jpg 640w, /images/photos/coach-tina-1280.jpg 1280w, /images/photos/coach-tina-1920.jpg 1920w, /images/photos/coach-tina-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/coach-tina-640.webp 640w, /images/photos/coach-tina-1280.webp 1280w, /images/photos/coach-tina-1920.webp 1920w, /images/photos/coach-tina-2560.webp 2560w",
  "width": 4000
 },
 "coach-ty": {
  "alt": "Ty, MX4 coach at Delta Valley Health Club",
  "focus": "50% 40%",
  "height": 5334,
  "sizes": "(max-width: 640px) 112px, 160px",
  "src": "/images/photos/coach-ty-1280.jpg",
  "srcSet": "/images/photos/coach-ty-640.jpg 640w, /images/photos/coach-ty-1280.jpg 1280w, /images/photos/coach-ty-1920.jpg 1920w, /images/photos/coach-ty-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/coach-ty-640.webp 640w, /images/photos/coach-ty-1280.webp 1280w, /images/photos/coach-ty-1920.webp 1920w, /images/photos/coach-ty-2560.webp 2560w",
  "width": 4000
 },
 "home-tour": {
  "alt": "Strength-training floor with racks beside the climbing wall",
  "focus": "50% 50%",
  "height": 1448,
  "sizes": "(max-width: 640px) 348px, 599px",
  "src": "/images/photos/strength-floor-1280.jpg",
  "srcSet": "/images/photos/strength-floor-640.jpg 640w, /images/photos/strength-floor-1280.jpg 1280w, /images/photos/strength-floor-1920.jpg 1920w, /images/photos/strength-floor-2172.jpg 2172w",
  "webpSrcSet": "/images/photos/strength-floor-640.webp 640w, /images/photos/strength-floor-1280.webp 1280w, /images/photos/strength-floor-1920.webp 1920w, /images/photos/strength-floor-2172.webp 2172w",
  "width": 2172
 },
 "journey-zumba": {
  "alt": "An instructor leading riders in a spin class",
  "focus": "84% 25%",
  "height": 1365,
  "sizes": "(max-width: 640px) 390px, 760px",
  "src": "/images/photos/spin-class-1280.jpg",
  "srcSet": "/images/photos/spin-class-640.jpg 640w, /images/photos/spin-class-1280.jpg 1280w, /images/photos/spin-class-1920.jpg 1920w, /images/photos/spin-class-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/spin-class-640.webp 640w, /images/photos/spin-class-1280.webp 1280w, /images/photos/spin-class-1920.webp 1920w, /images/photos/spin-class-2048.webp 2048w",
  "width": 2048
 },
 "membership-hero": {
  "alt": "The Delta Valley Health Club neon sign glowing on a club wall",
  "focus": "60% 50%",
  "height": 2982,
  "sizes": "(max-width: 640px) 390px, 760px",
  "src": "/images/photos/club-neon-sign-1280.jpg",
  "srcSet": "/images/photos/club-neon-sign-640.jpg 640w, /images/photos/club-neon-sign-1280.jpg 1280w, /images/photos/club-neon-sign-1920.jpg 1920w, /images/photos/club-neon-sign-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/club-neon-sign-640.webp 640w, /images/photos/club-neon-sign-1280.webp 1280w, /images/photos/club-neon-sign-1920.webp 1920w, /images/photos/club-neon-sign-2560.webp 2560w",
  "width": 3280
 },
 "schedule-F01-Cardio%20floor%20and%20treadmills": {
  "alt": "Cardio floor with treadmills",
  "focus": "50% 50%",
  "height": 800,
  "sizes": "(max-width: 640px) 350px, 605px",
  "src": "/images/facility/cardio-room.jpg",
  "width": 1200
 },
 "schedule-F05-Dumbbells%20on%20a%20training%20floor": {
  "alt": "A 35-pound dumbbell, gym bag and water bottle on the weight floor",
  "focus": "42% 62%",
  "height": 4000,
  "sizes": "(max-width: 640px) 350px, 605px",
  "src": "/images/photos/free-weights-1280.jpg",
  "srcSet": "/images/photos/free-weights-640.jpg 640w, /images/photos/free-weights-1280.jpg 1280w, /images/photos/free-weights-1920.jpg 1920w, /images/photos/free-weights-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/free-weights-640.webp 640w, /images/photos/free-weights-1280.webp 1280w, /images/photos/free-weights-1920.webp 1920w, /images/photos/free-weights-2560.webp 2560w",
  "width": 6000
 },
 "schedule-mind-body": {
  "alt": "Members holding a balance pose on yoga mats in a group class",
  "focus": "55% 32%",
  "height": 1275,
  "sizes": "(max-width: 640px) 350px, 605px",
  "src": "/images/photos/mind-body-class-1280.jpg",
  "srcSet": "/images/photos/mind-body-class-640.jpg 640w, /images/photos/mind-body-class-1280.jpg 1280w, /images/photos/mind-body-class-1920.jpg 1920w, /images/photos/mind-body-class-2048.jpg 2048w",
  "webpSrcSet": "/images/photos/mind-body-class-640.webp 640w, /images/photos/mind-body-class-1280.webp 1280w, /images/photos/mind-body-class-1920.webp 1920w, /images/photos/mind-body-class-2048.webp 2048w",
  "width": 2048
 },
 "swim-hero": {
  "alt": "Goggles, towel, kickboard and life ring beside the lap pool",
  "focus": "42% 58%",
  "height": 4000,
  "sizes": "(max-width: 640px) 390px, 720px",
  "src": "/images/photos/swim-gear-1280.jpg",
  "srcSet": "/images/photos/swim-gear-640.jpg 640w, /images/photos/swim-gear-1280.jpg 1280w, /images/photos/swim-gear-1920.jpg 1920w, /images/photos/swim-gear-2560.jpg 2560w",
  "webpSrcSet": "/images/photos/swim-gear-640.webp 640w, /images/photos/swim-gear-1280.webp 1280w, /images/photos/swim-gear-1920.webp 1920w, /images/photos/swim-gear-2560.webp 2560w",
  "width": 6000
 }
});
